import styled from "@emotion/styled";
import { motion } from "@smartsheet/design-tokens";
// This component is not meant to be shipped to consumers.
export const Badge = styled("span")`
    ${_ref => {
  let {
    backgroundColor,
    size,
    color
  } = _ref;
  return `
        box-sizing: content-box;
        background-color: ${backgroundColor};
        height: ${size}px;
        color: ${color};
        font-size: ${size === 16 ? 10 : 8}px;
        font-weight: 700;
        font-family: inherit;
        line-height: 8px;
        letter-spacing: -0.2px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: absolute;
        transition: all ${motion.animation.default};
    `;
}}
`;
//# sourceMappingURL=Badge.js.map